var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcl-busy",style:(_vm.widgetStyles)},[(_vm.busy)?_c('div',{staticClass:"vcl-busy__container"},[_c('VpIcon',{attrs:{"icon":"loading","spin":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }